import { useEffect } from 'react';
import { useDispatch } from 'react-redux';

/**
 * Хук, который отправляет socket.io события (emit-функции) при размонтировании компонента.
 *
 * @param {Function[]} stopEmitters - массив thunk-функций, которые вызываются при unmount
 *
 * @example
 * useSocketEmitOnUnmount([
 *   emitBrigadeListenStop,
 *   emitBrigadeAllSignalsListenStop,
 * ]);
 */
export const useSocketEmitOnUnmount = (stopEmitters = []) => {
  const dispatch = useDispatch();

  useEffect(() => {
    return () => {
      stopEmitters.forEach((emitFn) => {
        if (typeof emitFn === 'function') {
          dispatch(emitFn());
        }
      });
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
};
